// Unit system configuration schema
// Stores the unit set type and per-category unit preferences
// Source: C++ unit_pool with unit_set_type_t enum

import { z } from 'zod';
import { ValueWithUnitSchema } from '../base/common';

const UnitSetTypeSchema = z.enum(['US', 'SI_base', 'SI_common', 'metric', 'custom']);
const FlowUnitEnumSchema = z.enum(['MASS', 'VOL', 'STAND']);
const SupplyFrequencySchema = z.enum(['frequency_50_hertz', 'frequency_60_hertz']);

export const UnitSystemSchema = z.object({
  /** The base unit set type */
  unit_set: UnitSetTypeSchema,
  /** Whether pressures are displayed as gauge (relative) or absolute */
  gauge_pressures: z.boolean(),
  /** Reference atmospheric pressure for gauge conversions */
  atmospheric_pressure: ValueWithUnitSchema,
  /** How flow rates are displayed: mass, volumetric, or standard */
  flow_unit_type: FlowUnitEnumSchema,
  /** Electrical supply frequency for motor calculations */
  supply_frequency: SupplyFrequencySchema,
  /** Per-category unit preferences: category index → unit index */
  unit_preferences: z.record(z.string(), z.number()),
});

export type UnitSystem = z.infer<typeof UnitSystemSchema>;
